import React from 'react';
import './ArtistAvatar.css';

const ArtistAvatar = ({ artistName, artistImage, onClick }) => {
  return (
    <div className="artist-avatar-container" onClick={onClick} title={`Info about ${artistName}`}>
      <div className="artist-avatar-image-wrapper">
        {artistImage ? (
          <img 
            src={artistImage} 
            alt={artistName}
            className="artist-avatar-image"
          />
        ) : (
          <div className="artist-avatar-placeholder">
            <i className="bi bi-music-note-beamed"></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArtistAvatar;

